export function replaceContents(text: string, isHtmlMode?: boolean): string {
  // if (isHtmlMode) return text;
  if (!text) return '';

  // 🛠️ 1. HTML 태그와 텍스트를 분리하기 위해 정규식 사용
  const htmlTagRegex = /(<[^>]+>)/g;
  const parts = text.split(htmlTagRegex);

  // 🛠️ 2. URL 변환을 적용할 부분과 무시할 부분을 구분
  const urlWithBracketsRegex = /\[(https?:\/\/[^\s]+)]/g;
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  const transformedText = parts
    .map((part) => {
      // ✅ HTML 태그는 그대로 둠 (ex: <p>, <img> 등)
      if (part.match(/^<[^>]+>$/)) {
        return part;
      }

      // ✅ 대괄호로 감싼 URL 변환 (ex: [https://example.com] -> <a>링크</a>)
      const replacedBrackets = part.replace(
        urlWithBracketsRegex,
        (match, url) => {
          return `<a href="${url}" target="_blank" class="boardLink">${url}</a>`;
        },
      );

      // ✅ 일반적인 URL 변환 (ex: https://example.com -> <a>링크</a>)
      const replaceUrl = replacedBrackets.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" class="boardLink">${url}</a>`;
      });

      // ✅ 개행 문자 변환 (단, HTML 태그 내부에서는 적용되지 않음)
      return replaceUrl.replace(/(?:\r\n|\r|\n)/g, '<br />');
    })
    .join('');

  return transformedText;
}
